import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const SAVE_AS_FOLDERABLE_APP_CONFIG = {
    appName: 'FolderableSaveAsFolderModal',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Folders',
};
